import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import Typography from '../../../components/atomic/Typography';
import Greencheck from '../../../assets/icons/GreenCheckmark';
import BoligmappaPlusLogo from '../../../assets/icons/BoligmappaPlusLogo';
import useSearchQuery from '../../../hooks/useSearchQuery';
import matomo from '../../../utils/matomo';
import styles from './style';

const SuccessfulPurchase = ({ classes }) => {
  const VALUE_ESTIMATE = 'VALUE_ESTIMATE';
  const PERSONAL_AREA = 'PERSONAL_AREA';
  const LOYALTY = 'LOYALTY';
  const CONSENT = 'CONSENT';

  const history = useHistory();
  const { redirectUrl } = useSearchQuery();

  const [propertySection, setPropertySection] = useState(true);
  const [boligmappaNumber, setBoligmappaNumber] = useState(null);

  useEffect(() => {
    matomo.clickEvent({
      category: 'Boligmappa+',
      action: 'Subscription Successfully Purchased',
    });

    const url = `${new URL(redirectUrl).pathname}?subscribed=true`;
    if (url.includes('personal-area')) {
      setPropertySection(false);
    } else {
      setBoligmappaNumber(url.split('/')[2]);
      setPropertySection(true);
    }
  }, [history]);

  const handleRedirect = (page) => {
    if (page === PERSONAL_AREA) {
      history.push('/personal-area/dashboard/boligmappa-plus?subscribed=true');
    } else if (page === LOYALTY) {
      if (propertySection) {
        history.push(
          `/dashboard/${boligmappaNumber}/boligmappa-plus/loyalty?subscribed=true`
        );
      } else {
        history.push(
          '/personal-area/dashboard/boligmappa-plus/loyalty?subscribed=true'
        );
      }
    } else if (page === VALUE_ESTIMATE) {
      history.push(`/dashboard/${boligmappaNumber}/financials?subscribed=true`);
    } else if (page === CONSENT) {
      if (propertySection) {
        history.push(
          `/dashboard/${boligmappaNumber}/more/account?subscribed=true`
        );
      } else {
        history.push('/personal-area/dashboard/more/account?subscribed=true');
      }
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.dataContainer}>
        <div className={classes.header}>
          <Greencheck className={classes.checkIcon} />
          <Typography fontSize={16} fontWeight={500}>
            Velkommen til
          </Typography>
          <BoligmappaPlusLogo />
        </div>
        <div>
          <center>
            <Typography className={classes.textContent}>
              Vi setter opp din tilgang, dette kan ta noen minutter. Som medlem
              av Boligmappa+ får du tilgang til Boligmappas verdiestimat,
              fordelsprogram, et personlig område som følger deg for alltid - og
              mye mer.
            </Typography>
          </center>
        </div>
        <div>
          <center>
            <Typography fontSize={26} fontWeight={800}>
              Start med å utforske
            </Typography>
            <div>
              {propertySection && (
                <button
                  type="button"
                  className={classes.linkButton}
                  onClick={() => handleRedirect(VALUE_ESTIMATE)}
                >
                  Verdiestimat
                </button>
              )}
              <button
                type="button"
                className={classes.linkButton}
                onClick={() => handleRedirect(PERSONAL_AREA)}
              >
                Personlig område
              </button>
              <button
                type="button"
                className={classes.linkButton}
                onClick={() => handleRedirect(LOYALTY)}
              >
                Medlemsfordeler
              </button>
            </div>
          </center>
          <div className={classes.divider} />
          <center>
            <Typography fontSize={26} fontWeight={800}>
              Få siste nytt først
            </Typography>
            <Typography
              className={classes.newsLetterText}
              onClick={() => handleRedirect(CONSENT)}
            >
              Meld meg på nyhetsbrevet
            </Typography>
          </center>
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(SuccessfulPurchase);
